import "./styles.css";

/* -------------------------------------------------------------
   Mobile nav toggle
   ------------------------------------------------------------- */
const nav = document.querySelector(".nav");
const toggle = document.querySelector(".nav-toggle");
if (toggle && nav) {
  toggle.addEventListener("click", () => {
    const open = nav.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", String(open));
  });
  // Close on link click (mobile)
  nav.querySelectorAll("a").forEach((a) =>
    a.addEventListener("click", () => {
      nav.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    })
  );
}

/* -------------------------------------------------------------
   Scrollspy — highlight active nav link
   ------------------------------------------------------------- */
const links = Array.from(document.querySelectorAll(".nav__list a"));
const sections = links.map((a) => document.querySelector(a.getAttribute("href"))).filter(Boolean);

const spy = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        links.forEach((a) => a.classList.toggle("is-active", a.getAttribute("href") === `#${id}`));
      }
    });
  },
  { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
);
sections.forEach((s) => spy.observe(s));

/* -------------------------------------------------------------
   Variety filter chips
   ------------------------------------------------------------- */
const filterChips = document.querySelectorAll(".filterbar .chip");
const vcards = document.querySelectorAll(".vcard");

filterChips.forEach((chip) => {
  chip.addEventListener("click", () => {
    const filter = chip.getAttribute("data-filter");

    filterChips.forEach((c) => {
      c.classList.remove("chip--active");
      c.setAttribute("aria-selected", "false");
    });
    chip.classList.add("chip--active");
    chip.setAttribute("aria-selected", "true");

    vcards.forEach((card) => {
      const v = card.getAttribute("data-variety");
      const match = filter === "all" || v === filter;
      card.classList.toggle("is-dim", !match);
    });
  });
});

/* -------------------------------------------------------------
   KPI count-up on first reveal
   ------------------------------------------------------------- */
const kpis = document.querySelectorAll(".kpi[data-target]");
if (kpis.length && "IntersectionObserver" in window) {
  const seen = new WeakSet();
  const animate = (el) => {
    const raw = el.getAttribute("data-target") || "0";
    const target = parseFloat(raw);
    if (Number.isNaN(target)) return;
    const original = el.textContent;
    const suffix = original.replace(/[\d.,]/g, "").trim(); // e.g. "+", "%", "K"
    const duration = 900;
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      const value = Math.round(target * eased);
      el.textContent = `${value}${suffix}`;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = original;
    };
    requestAnimationFrame(step);
  };

  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          animate(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  kpis.forEach((k) => obs.observe(k));
}

/* -------------------------------------------------------------
   Contact form — POST enquiry to FormSubmit (AJAX endpoint).
   FormSubmit relays each submission to the trade-desk inbox.
   First-time activation: see README · "Contact form delivery".
   ------------------------------------------------------------- */
const FORMSUBMIT_URL = "https://formsubmit.co/ajax/suppala.ui@gmail.com";

const form = document.getElementById("contact-form");
if (form) {
  const status = form.querySelector(".form__status");
  const submitBtn = form.querySelector("button[type='submit']");

  const setStatus = (msg, kind) => {
    status.classList.remove("is-ok", "is-err");
    status.textContent = msg || "";
    if (kind) status.classList.add(`is-${kind}`);
  };

  const setLoading = (on) => {
    if (!submitBtn) return;
    submitBtn.disabled = on;
    submitBtn.classList.toggle("is-loading", on);
    const label = submitBtn.querySelector(".btn__label");
    if (label) label.textContent = on ? "Sending…" : "Send enquiry";
  };

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    setStatus("");

    const name = form.elements["name"].value.trim();
    const email = form.elements["email"].value.trim();
    const message = form.elements["message"].value.trim();

    if (!name || !email || !message) {
      setStatus("Please fill in name, email and message.", "err");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("That email doesn't look right.", "err");
      return;
    }

    setLoading(true);

    try {
      const fd = new FormData(form);
      const res = await fetch(FORMSUBMIT_URL, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: fd,
      });
      const data = await res.json().catch(() => ({}));

      // FormSubmit returns { success: "true", message: "..." } on success.
      const ok = res.ok && (data.success === "true" || data.success === true);
      if (!ok) throw new Error(data.message || "Submission failed");

      setStatus("Thanks — we'll be in touch within 24 hours.", "ok");
      form.reset();
    } catch (err) {
      setStatus(
        "We couldn't send that just now. Please email hello@vivardhaa.com or try again.",
        "err"
      );
    } finally {
      setLoading(false);
    }
  });
}
